var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg503Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 233,
    viewBox: "0 0 252 233",
    width: 252,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 81,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 85,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 29,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b1bbbd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 136,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 57,
    opacity: 0.502348,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 70,
    opacity: 0.502348,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 149,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 37,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.832 116.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.832 40.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(73 62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.01804688 79.6206641v-3.6263477l52.61888672-30.3793359 52.6184574 30.3793359v3.6263477l-52.6184574 30.3793359z",
    fill: "#e4eaeb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b1bbbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.7600977 72.3900977-16.6054883-66.81425786h-.0019336c-.202168-1.3868164-1.2149414-2.74076172-3.0426172-3.79607422-4.1101758-2.37294921-10.8356445-2.37294921-14.9458203 0-1.8276758 1.0553125-2.8406641 2.40925782-3.0426172 3.79607422h-.0019336l-16.6057031 66.81425786c-1.9559375 5.1742968.5317383 10.808789 7.4636719 14.8108984 10.8126562 6.2427148 28.5061132 6.2427148 39.3189843 0 6.9312891-4.0021094 9.4191797-9.6368164 7.4634571-14.8108984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.7600977 72.3900977-16.6054883-66.81425786h-.0019336c-.202168-1.3868164-1.2149414-2.74076172-3.0426172-3.79607422-4.1101758-2.37294921-10.8356445-2.37294921-14.9458203 0-1.8276758 1.0553125-2.8406641 2.40925782-3.0426172 3.79607422h-.0019336l-16.6057031 66.81425786c-1.9559375 5.1742968.5317383 10.808789 7.4636719 14.8108984 10.8126562 6.2427148 28.5061132 6.2427148 39.3189843 0 6.9312891-4.0021094 9.4191797-9.6368164 7.4634571-14.8108984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.6369336 106.373652v3.626348l-52.61888672-30.3793359v-3.6263477z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52.6369336 106.373652v3.626348l52.6184574-30.3793359v-3.6263477z",
    fill: "#929b9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.1640234 10.40875c-4.1101757-2.37294922-4.1101757-6.25603516 0-8.62898438 4.1101758-2.37294921 10.8356446-2.37294921 14.9458203 0 4.1101758 2.37294922 4.1101758 6.25603516 0 8.62898438-4.1101757 2.3729492-10.8358593 2.3729492-14.9458203 0z",
    fill: "#e4eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.1529297 8.68291016c-2.4659766-1.42376953-2.4659766-3.75353516 0-5.17730469s6.5013867-1.42376953 8.9675781 0c2.4659766 1.42376953 2.4659766 3.75353516 0 5.17730469-2.4659765 1.42376954-6.5013867 1.42376954-8.9675781 0z",
    fill: "#929b9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.6179102 55.7248828-5.6503907-22.7347656c-.7040429.5880273-1.5047656 1.1479101-2.4094726 1.6701953-8.2070313 4.7381641-21.6364844 4.7381641-29.8433008 0-.904707-.5222852-1.7052149-1.082168-2.4094727-1.6701953l-5.6503906 22.7345508c1.0894727 1.1945312 2.4066797 2.3211718 3.9557031 3.3502734 10.4639649 6.9523438 27.5872266 6.9523438 38.0511914 0 1.5494532-1.0288867 2.8670899-2.1557422 3.9561329-3.3500586z",
    fill: "#e9eff0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg503Error);
export default __webpack_public_path__ + "static/media/503-error.246b5f34c1ae1de9c3677c3dda2a57ce.svg";
export { ForwardRef as ReactComponent };